import InsightSelect from '@/components/selects/InsightSelect';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';

const InsurancePortfolioSelect = () => {
	const { values, setFieldValue } = useFormikContext();

	return (
		<>
			<FormControl fullWidth>
				<FormLabel>Portfolio template</FormLabel>
				<InsightSelect
					endpoint={'/ClientInsurancePortfolio/List'}
					autofillIfNull
					value={values.portfolioTemplate}
					clearable={true}
					onChange={(v) => {
						setFieldValue(
							'portfolioTemplate',
							v
								? {
										Name: v.Name,
										Id: v.Id,
									}
								: null,
						);
					}}
				/>
				<FormHelperText>
					Choose the template for generating the Client Insurance Portfolio
				</FormHelperText>
			</FormControl>
		</>
	);
};
export default InsurancePortfolioSelect;
